<div class="dashboard-hero mb-4">
  <div class="dashboard-hero-icon">
    <i class="ri-shield-star-line"></i>
  </div>
  <div class="dashboard-hero-text">
    <h1
      class="mb-1"
      i18n="@@dashboardAdminTitle"
    >Superadmin Dashboard</h1>
    <p
      class="text-muted mb-0"
      i18n="@@dashboardAdminIntro"
    >Überblick über Mandanten, Nutzer und Kacheln im gesamten Portal.</p>
  </div>
  <nav
    class="hero-links"
    i18n-aria-label="@@dashboardAdminQuickLinks"
    aria-label="Schnellzugriff"
  >
    <a
      routerLink="/admin/tiles"
      class="quick-link"
    >
      <i class="ri-layout-grid-line"></i>
      <span i18n="@@navTileAdmin">Kachelverwaltung</span>
    </a>
    <a
      routerLink="/admin/mandants"
      class="quick-link"
    >
      <i class="ri-building-line"></i>
      <span i18n="@@navMandantAdmin">Mandantenverwaltung</span>
    </a>
    <a
      routerLink="/admin/users"
      class="quick-link"
    >
      <i class="ri-user-star-line"></i>
      <span i18n="@@navGlobalUserAdmin">Globale Nutzerverwaltung</span>
    </a>
    <a
      routerLink="/admin/settings"
      class="quick-link"
    >
      <i class="ri-settings-3-line"></i>
      <span i18n="@@navSettingsAdmin">Einstellungen</span>
    </a>
  </nav>
</div>

<div
  *ngIf="loading"
  class="text-center text-muted py-5"
>
  <i class="ri-loader-4-line ri-spin fs-2"></i>
</div>

<div
  *ngIf="!loading && loadError"
  class="alert alert-danger"
  i18n="@@dashboardAdminLoadError"
>Die Dashboard-Daten konnten nicht geladen werden. Bitte lade die Seite neu.</div>

<ng-container *ngIf="!loading && !loadError">
  <!-- Kennzahlen-Kacheln -->
  <div class="row g-3 mb-3">
    <div class="col-12 col-sm-6 col-xl-3">
      <p-card styleClass="stat-card">
        <div class="stat-card-body">
          <div class="stat-icon bg-primary-subtle text-primary">
            <i class="ri-building-line"></i>
          </div>
          <div>
            <div class="stat-value">{{ mandantCount }}</div>
            <div
              class="stat-label"
              i18n="@@dashboardAdminMandants"
            >Mandanten</div>
            <div
              class="stat-sublabel"
              i18n="@@dashboardAdminAvgTiles"
            >Ø {{ avgTilesPerMandant }} Kacheln pro Pool</div>
          </div>
        </div>
      </p-card>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <p-card styleClass="stat-card">
        <div class="stat-card-body">
          <div class="stat-icon bg-info-subtle text-info">
            <i class="ri-user-star-line"></i>
          </div>
          <div>
            <div class="stat-value">{{ userCount }}</div>
            <div
              class="stat-label"
              i18n="@@dashboardAdminUsers"
            >Globale Nutzer</div>
            <div
              class="stat-sublabel"
              i18n="@@dashboardAdminReflactAdmins"
            >{{ reflactAdminCount }} Reflact Admins</div>
          </div>
        </div>
      </p-card>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <p-card styleClass="stat-card">
        <div class="stat-card-body">
          <div class="stat-icon bg-warning-subtle text-warning">
            <i class="ri-layout-grid-line"></i>
          </div>
          <div>
            <div class="stat-value">{{ tileCount }}</div>
            <div
              class="stat-label"
              i18n="@@dashboardAdminTiles"
            >Kacheln</div>
            <div
              class="stat-sublabel"
              i18n="@@dashboardAdminTilesSplit"
            >{{ applicationTileCount }} Applications · {{ linkTileCount }} Links</div>
          </div>
        </div>
      </p-card>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <p-card styleClass="stat-card">
        <div class="stat-card-body">
          <app-simple-pie
            [percent]="twoFactorPercent"
            [autoColor]="false"
            color="#22c55e"
            [diameter]="48"
          ></app-simple-pie>
          <div>
            <div class="stat-value">{{ twoFactorPercent }}%</div>
            <div
              class="stat-label"
              i18n="@@dashboardAdmin2FA"
            >Nutzer mit 2FA</div>
            <div
              class="stat-sublabel"
              i18n="@@dashboardAdmin2FACount"
            >{{ twoFactorEnabledCount }} von {{ userCount }} Nutzern</div>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</ng-container>

<!-- Lädt unabhängig von den Bestandsdaten, damit ein Fehler dort die Nutzungsdaten nicht verdeckt -->
<app-activity-insights></app-activity-insights>

<ng-container *ngIf="!loading && !loadError">
  <div class="row g-3 mb-3">
    <!-- Top Mandanten nach Kachelanzahl -->
    <div class="col-12 col-lg-7">
      <p-card styleClass="h-100">
        <ng-template pTemplate="header">
          <div
            class="p-3 fw-bold"
            i18n="@@dashboardAdminTopMandants"
          >Mandanten nach Größe des Kachel-Pools</div>
        </ng-template>
        <div
          *ngIf="topMandantsByTiles.length === 0"
          class="text-muted"
          i18n="@@mandantAdminNoData"
        >Noch keine Mandanten vorhanden.</div>
        <div
          *ngFor="let entry of topMandantsByTiles"
          class="d-flex align-items-center mb-3"
        >
          <div class="flex-grow-1">
            <div class="fw-medium">{{ entry.mandant.name }}</div>
            <div
              class="progress"
              style="height: 6px;"
            >
              <div
                class="progress-bar bg-primary"
                [style.width.%]="tileCount > 0 ? (entry.tileCount / tileCount * 100) : 0"
              ></div>
            </div>
          </div>
          <span class="badge bg-primary ms-3">{{ entry.tileCount }}</span>
        </div>
      </p-card>
    </div>

    <!-- Systemstatus -->
    <div class="col-12 col-lg-5">
      <p-card styleClass="h-100">
        <ng-template pTemplate="header">
          <div
            class="p-3 fw-bold"
            i18n="@@dashboardAdminSystemStatus"
          >Systemstatus</div>
        </ng-template>
        <p
          class="mb-2"
          *ngIf="openAiConfigured"
        >
          <i class="ri-checkbox-circle-line text-success me-1"></i>
          <span i18n="@@settingsOpenAiConfigured">Ein API-Key ist hinterlegt.</span>
        </p>
        <p
          class="mb-2"
          *ngIf="!openAiConfigured"
        >
          <i class="ri-close-circle-line text-danger me-1"></i>
          <span i18n="@@settingsOpenAiNotConfigured">Es ist noch kein API-Key hinterlegt.</span>
        </p>
        <div
          *ngIf="mandantsWithoutTiles.length > 0"
          class="alert alert-warning d-flex align-items-start gap-2 mb-0"
        >
          <i class="ri-error-warning-line fs-5"></i>
          <div>
            <div
              class="fw-medium"
              i18n="@@dashboardAdminMandantsWithoutTilesTitle"
            >Mandanten mit leerem Kachel-Pool</div>
            <div i18n="@@dashboardAdminMandantsWithoutTilesText">{{ mandantsWithoutTiles.length }} Mandant(en) haben
              einen leeren Kachel-Pool.</div>
          </div>
        </div>
      </p-card>
    </div>
  </div>
</ng-container>
